import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { createPinia } from "pinia";
import * as ElementPlusIconsVue from "@element-plus/icons-vue"; // 引入 Element Plus 图标
import "katex/dist/katex.min.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs"; // 引入中文语言包
const app = createApp(App);
const pinia = createPinia();

// 注册 Element Plus（只注册一次）
app.use(ElementPlus, { locale: zhCn });

// 注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 使用其他插件
app.use(store).use(router).use(pinia).mount("#app");
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
